import React, {useState, useEffect, useRef, useCallback} from "react";
import Loader from "react-loaders";
import {GoogleMap, useJsApiLoader, Marker} from '@react-google-maps/api';

const libraries = ['places'];

const GoogleMapWrapper = ({
    location,
    marker = null,
    width = '100%',
    height = '100%',
    style = {},
    zoom = 3,
    modes = false,
    callback = () => {}
}) => {

    const defaultOption = {
        panControl: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        clickableIcons: true,
        keyboardShortcuts: false,
        scrollwheel: modes,
        disableDoubleClickZoom: false,
        fullscreenControl: true,
    };

    const defaultCenter = location ? location : {
        lat: 57.8642403,
        lng: 63.9506995
    };

    const [center, setCenter] = useState(defaultCenter);
    const [positionMarker, setPositionMarker] = useState(marker);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyBRvzTEpqsPqBPROdVuqkPxGTlOTjnPTHw",
        libraries
    });

    const mapRef = useRef(undefined);

    const onLoad = useCallback(function callback(map) {
        mapRef.current = map;
    }, []);

    const onUnmount = useCallback(function callback(map) {
        mapRef.current = undefined;
    }, []);

    const getBrowserLocation = () => {
        return new Promise((resolve, reject) => {
            if('geolocation' in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (pos) => {
                        const { latitude: lat, longitude: lng } = pos.coords;
                        resolve({ lat, lng });
                    },
                    () => {
                        reject(defaultCenter);
                    },
                );
            } else {
                 reject(defaultCenter);
            }
        });
    };

    useEffect(() => {
        if (modes) {
            getBrowserLocation().then((curloc) => {
                setCenter(curloc);
            }).catch((defaultLocation) => {
                setCenter(defaultLocation);
            });
        }
    }, []);

    const setMarker = (loc) => {
        if (modes) {
            const lat = loc.latLng.lat();
            const lng = loc.latLng.lng();
            setPositionMarker({lat, lng});
            callback({lat, lng});
        }
    }

    return isLoaded ?
    (
        <GoogleMap
            mapContainerStyle={{width, height, ...style}}
            center={center}
            zoom={zoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={defaultOption}
            onClick={setMarker}
        >
            {positionMarker && <Marker position={positionMarker} />}
        </GoogleMap>
    ) :
    <div className='d-flex align-items-center justify-content-center' style={{width, height}}>
        <Loader type="line-scale-party"/>
    </div>
}


export default React.memo(GoogleMapWrapper);